import { AlertCircle, RefreshCw } from 'lucide-react';
import Button from '../Button';
import type { ErrorStateProps } from './ErrorState.types';
import './ErrorState.scss';

export default function ErrorState({
  title = 'Что-то пошло не так', description, retry, retryLabel = 'Повторить', className,
}: ErrorStateProps) {
  return (
    <div className={['error-state', className || ''].filter(Boolean).join(' ')} role="alert">
      <span className="error-state__icon" aria-hidden="true"><AlertCircle size={28} /></span>
      <h3 className="error-state__title">{title}</h3>
      {description ? <p className="error-state__description">{description}</p> : null}
      {retry ? (
        <div className="error-state__cta">
          <Button variant="secondary" iconLeft={<RefreshCw size={14} />} onClick={retry}>
            {retryLabel}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
